// import React, { useState, useEffect } from "react";
// import AdminAppBody from "../../../../components/admin/AdminAppBody";
// import PageHeading from "../../../../components/admin/common/PageHeading";
// import useApiCallHooks from "../../../../hooks/useApiCallHooks";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// const AddBlog = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     description: "",
//     image: null,
//     category: "",
//     created_by: "",
//   });

//   const [imagePreview, setImagePreview] = useState(null);
//   const navigate = useNavigate();
//   const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

//   useEffect(() => {
//     if (response?.data && statusCode === 201) {
//       toast.success("Blog added successfully!");
//       setTimeout(() => {
//         navigate(uiRoutes.admin.blog.list);
//       }, 1000);
//     }
//   }, [response, statusCode, navigate]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const submitData = new FormData();
//     Object.keys(formData).forEach((key) => {
//       submitData.append(key, formData[key]);
//     });
//     callAPI("post", "admin/blogs", submitData);
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     setFormData({ ...formData, image: file });
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setImagePreview(reader.result);
//       reader.readAsDataURL(file);
//     } else {
//       setImagePreview(null);
//     }
//   };

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="container mt-5">
//           <PageHeading title="Add Blog" subTitle="Fill out the blog details" />
//           <div className="container card p-4 shadow-sm mt-3">
//             <form
//               onSubmit={handleSubmit}
//               className="row g-3"
//               encType="multipart/form-data"
//             >
//               <h6 className="">Add Blog Form</h6>

//               <div className="col-md-6">
//                 <label className="form-label">Blog Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.name}
//                   onChange={(e) =>
//                     setFormData({ ...formData, name: e.target.value })
//                   }
//                 />
//               </div>

//               <div className="col-md-6">
//                 <label className="form-label">Category</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.category}
//                   onChange={(e) =>
//                     setFormData({ ...formData, category: e.target.value })
//                   }
//                 />
//               </div>

//               <div className="col-md-6">
//                 <label className="form-label">Created By</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.created_by}
//                   onChange={(e) =>
//                     setFormData({ ...formData, created_by: e.target.value })
//                   }
//                 />
//               </div>

//               <div className="col-md-6">
//                 <label className="form-label">Blog Image</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   className="form-control"
//                   onChange={handleImageChange}
//                 />
//                 {imagePreview && (
//                   <img
//                     src={imagePreview}
//                     alt="Preview"
//                     className="mt-2"
//                     style={{
//                       width: "100%",
//                       maxHeight: "200px",
//                       objectFit: "contain",
//                     }}
//                   />
//                 )}
//               </div>

//               <div className="col-md-12">
//                 <label className="form-label">Description</label>
//                 <textarea
//                   className="form-control"
//                   rows="6"
//                   value={formData.description}
//                   onChange={(e) =>
//                     setFormData({ ...formData, description: e.target.value })
//                   }
//                 />
//               </div>

//               <div className="col-4 mt-4 mb-5">
//                 <button type="submit" className="btn btn-primary w-100">
//                   Submit
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default AddBlog;

import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// Draft.js imports
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const AddBlog = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    image: null,
    category: "",
    created_by: "",
  });

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    if (response?.data && statusCode === 201) {
      toast.success("Blog added successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.blog.list);
      }, 1000);
    }
  }, [response, statusCode, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Convert DraftJS content to HTML
    const htmlDescription = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    const submitData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "description") {
        submitData.append("description", htmlDescription);
      } else {
        submitData.append(key, formData[key]);
      }
    });

    callAPI("post", "admin/blogs", submitData);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
    }
  };

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-5">
          <PageHeading title="Add Blog" subTitle="Fill out the blog details" />
          <div className="container card p-4 shadow-sm mt-3">
            <form
              onSubmit={handleSubmit}
              className="row g-3"
              encType="multipart/form-data"
            >
              <h6 className="">Add Blog Form</h6>

              <div className="col-md-6">
                <label className="form-label">Blog Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Category</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.category}
                  onChange={(e) =>
                    setFormData({ ...formData, category: e.target.value })
                  }
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Created By</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.created_by}
                  onChange={(e) =>
                    setFormData({ ...formData, created_by: e.target.value })
                  }
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Blog Image</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleImageChange}
                />
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="mt-2"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      objectFit: "contain",
                    }}
                  />
                )}
              </div>

              <div className="col-md-12">
                <label className="form-label">Description</label>
                <Editor
                  editorState={editorState}
                  onEditorStateChange={setEditorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor form-control"
                  toolbarClassName="toolbar-class"
                  toolbar={{
                    options: ["inline", "blockType", "list", "link", "image", "history"],
                  }}
                  placeholder="Write your blog description..."
                />
              </div>

              <div className="col-4 mt-4 mb-5">
                <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default AddBlog;
